import { Box, Typography } from "@mui/material";
import { SwapVert as SwapVertIcon } from "@mui/icons-material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

export const campaignColumns = ({
  onRowClick,
  onSort,
  sortBy,
  sortOrder,
  primaryColor,
  activeView,
}) => [
  {
    accessorKey: "name",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">Campaign Name</Typography>
        {sortBy === "name" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("name")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("name")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("name")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => {
      const hasClicks = row.original.clickCount && row.original.clickCount > 0;
      const isCreatedView = activeView === "created";
      const isClickable = !isCreatedView || hasClicks;

      return (
        <Box
          component="span"
          sx={{
            marginLeft: 1,
            fontWeight: "bold",
            color: primaryColor,
            cursor: isClickable ? "pointer" : "not-allowed",
            "&:hover": {
              textDecoration: isClickable ? "underline" : "none",
            },
            // opacity: isClickable ? 1 : 0.6,
          }}
          onClick={() => isClickable && onRowClick && onRowClick(row.original)}
        >
          {row.original.name}
        </Box>
      );
    },
  },
  {
    accessorKey: "type",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">Type</Typography>
        {sortBy === "type" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("type")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("type")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("type")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => (
      <Box component="span" sx={{ marginLeft: 1 }}>
        {row.original.type || 0}
      </Box>
    ),
  },
  {
    accessorKey: "clickCount",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">Clicks</Typography>
        {sortBy === "clickcount" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("clickCount")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("clickCount")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("clickCount")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => (
      <Box component="span" sx={{ marginLeft: 1, fontWeight: "bold" }}>
        {row.original.clickCount || 0}
      </Box>
    ),
  },
  // Add createdDate column only for created campaigns view
  ...(activeView === "created"
    ? [
        {
          accessorKey: "createdDate",
          header: ({ table }) => (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2">Created Date</Typography>
              {sortBy === "createddate" ? (
                sortOrder === "asc" ? (
                  <ArrowUpward
                    fontSize="small"
                    style={{ cursor: "pointer" }}
                    onClick={() => onSort("createdDate")}
                  />
                ) : (
                  <ArrowDownward
                    fontSize="small"
                    style={{ cursor: "pointer" }}
                    onClick={() => onSort("createdDate")}
                  />
                )
              ) : (
                <SwapVertIcon
                  fontSize="small"
                  onClick={() => onSort("createdDate")}
                  style={{ cursor: "pointer" }}
                />
              )}
            </div>
          ),
          cell: ({ row }) => {
            const dateValue =
              row.original.createdDate ||
              row.original.createdAt ||
              row.original.dateCreated;
            let formattedDate = "N/A";

            if (dateValue) {
              try {
                formattedDate = new Date(dateValue).toLocaleDateString();
              } catch (error) {
                formattedDate = dateValue;
              }
            }

            return (
              <Box component="span" sx={{ marginLeft: 1 }}>
                {formattedDate}
              </Box>
            );
          },
        },
      ]
    : []),
];

export const articleColumns = ({
  onRowClick,
  onSort,
  sortBy,
  sortOrder,
  primaryColor,
}) => [
  {
    accessorKey: "name",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">Article name</Typography>
        {sortBy === "name" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("name")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("name")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("title")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => (
      <Box
        component="span"
        sx={{
          marginLeft: 1,
          fontWeight: "bold",
          color: primaryColor,
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
        onClick={() => onRowClick && onRowClick(row.original)}
      >
        {row.original.name}
      </Box>
    ),
  },
  {
    accessorKey: "clickCount",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">Clicks</Typography>
        {sortBy === "clickCount" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("clickCount")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("clickCount")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("clickCount")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => (
      <Box component="span" sx={{ marginLeft: 1, fontWeight: "bold" }}>
        {row.original.clickCount || 0}
      </Box>
    ),
  },
];

export const userColumns = ({ onSort, sortBy, sortOrder }) => [
  {
    accessorKey: "name",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">User Name</Typography>
        {sortBy === "name" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("name")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("name")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("name")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => (
      <Box component="span" sx={{ marginLeft: 1 }}>
        {row.original.name || "N/A"}
      </Box>
    ),
  },
  {
    accessorKey: "id",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">User ID</Typography>
        {sortBy === "id" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("id")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("id")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("id")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => (
      <Box component="span" sx={{ marginLeft: 1 }}>
        {row.original.id}
      </Box>
    ),
  },
  {
    accessorKey: "clickCount",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">Click Count</Typography>
        {sortBy === "clickCount" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("clickCount")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("clickCount")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("clickCount")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => (
      <Box component="span" sx={{ marginLeft: 1 }}>
        {row.original.clickCount || 0}
      </Box>
    ),
  },
  {
    accessorKey: "lastClick",
    header: ({ table }) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2">Clicked At</Typography>
        {sortBy === "lastClick" ? (
          sortOrder === "asc" ? (
            <ArrowUpward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("lastClick")}
            />
          ) : (
            <ArrowDownward
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => onSort("lastClick")}
            />
          )
        ) : (
          <SwapVertIcon
            fontSize="small"
            onClick={() => onSort("lastClick")}
            style={{ cursor: "pointer" }}
          />
        )}
      </div>
    ),
    cell: ({ row }) => {
      const dateValue = row.original.lastClick;
      let formattedDate = "N/A";

      if (dateValue) {
        try {
          formattedDate = new Date(dateValue).toLocaleString();
        } catch (error) {
          formattedDate = dateValue;
        }
      }

      return (
        <Box component="span" sx={{ marginLeft: 1 }}>
          {formattedDate}
        </Box>
      );
    },
  },
];
